import { ContextoModuloEnum } from "@/core/domain/enums/privado/aplicacao/modulo/contexto-modulo.enum";
import { AbstractStatusDTOBase } from "../../../abstract-status.dto.base";
import { FuncionalidadeDTO } from "./funcionalidade.dto";

export class ModuloDTO extends AbstractStatusDTOBase {
    index: number;
    nome: string;
    contexto: ContextoModuloEnum;
    icone?: string;
    moduloPaiId?: number;
    moduloPaiNome?: string;
    moduloPaiIcone?: string;
    funcionalidades?: Array<FuncionalidadeDTO>;
    modulosFilhos?: Array<ModuloDTO>;
}
